type Price = { low: number, high: number } | number
type FormatPriceType = (price: Price, currency?, options?) => string

declare module '#app' {
  interface NuxtApp {
    $formatPrice: FormatPriceType
  }
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $formatPrice: FormatPriceType
  }
}
export default defineNuxtPlugin(() => {
  const locale = useLocale()

  const formatPrice = (price: Price, currency: string = 'USD', options?: Intl.NumberFormatOptions) => {
    const values = isObject(price)
      ? [price.low, price.high]
      : [price]
    if (!currency) return price
    const nf = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: getCurrencyDisplay(currency),
      ...options,
    })
    return values.map((v) => nf.format(v)).join(' – ')
  }
  return {
    provide: {
      formatPrice
    }
  }
})
